// extracted by mini-css-extract-plugin
export default {"textButton":"TextButton_textButton__NtTlc"};